import React from 'react';
import Nav from '../../components/Nav/Nav';
import Landing from '../../components/Landing/Landing';
import MidImage from '../../components/MidImage/MidImage';
import Team from '../../components/Team/Team';
import TechUsed from '../../components/TechUsed/TechUsed';
import './HomePage.css';
import ApiExample from '../../components/APIExample/APIExample';
import StatsHighlight from '../../components/StatsHighlight/StatsHighlight';
import MissionStatement from '../../components/MissionStatement/MissionStatement';

function HomePage() {
  return (
    <>
      <Nav />
      <Landing />
      <ApiExample/>
      <StatsHighlight/>
      <MidImage />
      <MissionStatement/>
      <Team />
      <TechUsed />
      <footer className="bg-light text-center p-3 mt-5">
        <p className="mb-0">© 2025 UPSelf. All rights reserved.</p>
      </footer>
    </>
  );
}

export default HomePage;
